import "./SettingAfter.scss";
import { Iconfont, Button } from "@eweadn-qiankun/shared-components";
import { useTranslation } from "react-i18next";
import { isHuafendaMagneticAxisEquipment } from "@eweadn-qiankun/shared-utils";
import Socd from "./Socd";
import Dks from "./Dks";
import Mpt from "./Mpt";
import Mt from "./Mt";
import Tgl from "./Tgl";
import End from "./End";
import Rs from "./Rs";
import SnapKey from "./SnapKey";
import Mds from "./Mds";
import Cb from "./Cb";
import { useSdkApi } from "../../stores/sdkStore";

const settingAfter = (props: any) => {
  const { t } = useTranslation();
  const {
    checkData,
    getAfterChangeData,
    onSubmit,
    onClose,
    // isSubmitting = false,
    getElementXy,
    onBeforeOpenKeyPicker,
    readOnly = false,
  } = props;
  const globalSdkApi = useSdkApi();
  const sdkApi = globalSdkApi?.keyboard;
  const { sdkKeyboardBasicApi } = sdkApi || {};
  const getCurrentEquipmentData = sdkKeyboardBasicApi?.getCurrentEquipmentData;
  const equipment = getCurrentEquipmentData?.() ?? null;
  const solutionRovider = equipment?.solutionRovider;
  const isMagnetic = isHuafendaMagneticAxisEquipment(equipment);

  const selectData = checkData?.selectData ?? [];
  const wizardSteps = checkData?.wizard?.steps ?? [];
  /** 仅「当前应选」的空槽显示常驻提示：前面槽位都已选完，且本槽无 label */
  const showPressKeySelectHint = (index: number) => {
    if (selectData[index]?.label) return false;
    for (let i = 0; i < index; i++) {
      if (!selectData[i]?.label) return false;
    }
    return true;
  };

  const selectDataAllFilled = selectData.every((item: any) =>
    Boolean(item?.label)
  );
  const triggerDataHasValue = (() => {
    const td = checkData?.triggerData;
    if (!td) return false;
    // CB（value=8）：两个修饰键至少一个有值 + 常规按键有值
    if (checkData.value === 8) {
      const hasModifier =
        Boolean(td[0]?.label || td[0]?.code) ||
        Boolean(td[1]?.label || td[1]?.code);
      const hasRegular = Boolean(td[2]?.label || td[2]?.code);
      return hasModifier && hasRegular;
    }
    return td.some((item: any) => Boolean(item?.label || item?.code));
  })();
  const confirmDisabled = !selectDataAllFilled || !triggerDataHasValue;

  return (
    <div
      className={`setting-after-container${
        readOnly ? " setting-after-container--readonly" : ""
      }${isMagnetic ? " setting-after-container--magnetic" : ""}`}
    >
      <div className="setting-after-header">
        <div className="setting-after-header-left">
          <div className="header-left-back" onClick={() => onClose()}>
            <Iconfont icon="back1" style={{ marginRight: "4px" }} />
            <span>{t("common.back")}</span>
          </div>
          <div className="header-left-mode">
            <span className="header-left-mode-title">
              {checkData.titleKey ? t(checkData.titleKey) : checkData.title}
            </span>
            <span className="header-left-mode-desc">
              {checkData.descKey
                ? t(checkData.descKey)
                : checkData.desc || checkData.cn}
            </span>
          </div>
        </div>
        <div className="setting-after-header-right">
          {readOnly ? null : (
            <>
              <Button
                variant="default"
                className="cancel-button"
                onClick={() => onClose()}
              >
                {t("keyboard.button.cancel")}
              </Button>
              <Button
                variant="primary"
                className="confirm-button"
                disabled={confirmDisabled}
                style={confirmDisabled ? { opacity: 0.45 } : undefined}
                onClick={() => onSubmit()}
              >
                {t("keyboard.button.confirm")}
              </Button>
            </>
          )}
        </div>
      </div>
      <div className="setting-after-content">
        <div
          className="advance-setting-box"
          data-ui-workshop-slot="advancedKeyBar"
        >
          <div className="advance-setting-box-header">
            <div className="advance-setting-box-header-title">
              {wizardSteps[0]?.titleKey ? t(wizardSteps[0].titleKey) : ""}
            </div>
            <div className="advance-setting-box-header-desc">
              {wizardSteps[0]?.descKey ? t(wizardSteps[0].descKey) : ""}
            </div>
          </div>
          <div className="advance-select-common">
            <div className="select-presskey-box">
              {selectData.map((item: any, key: number) => {
                const hintVisible = showPressKeySelectHint(key);
                return (
                  <div
                    className={`base-pressKey ${hintVisible ? "no-select" : ""}`}
                    key={key}
                  >
                    <div className={`pressKey ${item.label ? "isActive" : ""}`}>
                      {item.label}
                    </div>
                    <div className="pressKey-desc">
                      {item.label
                        ? selectData.length > 1
                          ? t("keyboard.advancedKey.baseModesText.keys", {
                              num: key + 1,
                            })
                          : t("keyboard.advancedKey.baseModesText.selectedKey")
                        : t("keyboard.advancedKey.baseModesText.selectKey", {
                            num: selectData.length > 1 ? key + 1 : null,
                          })}
                    </div>
                    <div
                      className={`select-checkbox ${item.label ? "active" : ""}`}
                    >
                      <svg
                        className="select-checkbox-icon"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.5 4.5L6 12L2.5 8.5"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="step-content1-tips">
              <Iconfont icon="warning" className="tips-icon" />
              <span>
                {t("keyboard.advancedKey.baseModesText.selectKeyTips1")}
              </span>
            </div>
          </div>
        </div>
        {checkData.en === "SOCD" ? (
          <Socd
            checkData={checkData}
            getAfterChangeData={getAfterChangeData}
            isMagnetic={isMagnetic}
            keyboardType={String(equipment?.keyboardType ?? "")}
          />
        ) : checkData.en === "RS" ? (
          <Rs
            checkData={checkData}
            getAfterChangeData={getAfterChangeData}
            isMagnetic={isMagnetic}
            keyboardType={String(equipment?.keyboardType ?? "")}
          />
        ) : checkData.en === "SNAPKEY" ? (
          <SnapKey
            checkData={checkData}
            getAfterChangeData={getAfterChangeData}
            isMagnetic={isMagnetic}
          />
        ) : checkData.en === "MDS" ? (
          <Mds
            checkData={checkData}
            getAfterChangeData={getAfterChangeData}
            isMagnetic={isMagnetic}
          />
        ) : checkData.en === "DKS" ? (
          <Dks
            checkData={checkData}
            getAfterChangeData={getAfterChangeData}
            getElementXy={getElementXy}
            isMagnetic={isMagnetic}
            keyboardType={String(equipment?.keyboardType ?? "")}
          />
        ) : checkData.en === "MPT" ? (
          <Mpt
            checkData={checkData}
            getAfterChangeData={getAfterChangeData}
            getElementXy={getElementXy}
          />
        ) : checkData.en === "MT" ? (
          <Mt
            checkData={checkData}
            getAfterChangeData={getAfterChangeData}
            getElementXy={getElementXy}
            isHuafenda={solutionRovider === "huafenda"}
          />
        ) : checkData.en === "TGL" ? (
          <Tgl
            checkData={checkData}
            getAfterChangeData={getAfterChangeData}
            getElementXy={getElementXy}
          />
        ) : checkData.en === "END" ? (
          <End
            checkData={checkData}
            getAfterChangeData={getAfterChangeData}
            getElementXy={getElementXy}
          />
        ) : checkData.en === "CB" ? (
          <Cb
            checkData={checkData}
            getAfterChangeData={getAfterChangeData}
            getElementXy={getElementXy}
            onBeforeOpenKeyPicker={onBeforeOpenKeyPicker}
          />
        ) : null}
      </div>
    </div>
  );
};
export default settingAfter;
